import { ConversationStatus, IConversation } from '@/models/conversation.model';
import { DateFormats } from '@/constants/dates';
import { renderDate } from '@/utils';

export const getConversationPeriodLabel = (conversation: IConversation) => {
  const startedAtLabel = renderDate(conversation.startedAt, DateFormats.DATE_WITH_TIME);

  if (conversation.state === ConversationStatus.IN_PROGRESS) return startedAtLabel;

  const endedAtLabel = conversation.endedAt ? renderDate(conversation.endedAt, DateFormats.DATE_WITH_TIME) : '—';

  return `${startedAtLabel} → ${endedAtLabel}`;
};
